import { ValidationMessageModel } from "./models";

/*
 * Валидация электронной почты
 * @param value Адрес электронной почты
 * @param params Дополнительные параметры
 * @returns
 */
export const EmailValidation = (value: string): ValidationMessageModel => {
  const result = new ValidationMessageModel(false, "Пожалуйста, введите адрес электронной почты");
  if (value) {
    const regex =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
    result.IsSuccess = regex.test(value);
    if (!result.IsSuccess) {
      result.Message =
        "Адрес электронной почты должен содержать: имя@домен.ru и доменную зону (.ru)";
    }
  }
  return result;
};
